<template>
  <div class="mass-overlay" @click.self="$emit('close')">
    <div class="mass-modal">
      <h5>Массовая замена адреса трекера</h5>
      <div class="mode-switch">
        <label><input type="radio" value="replace" v-model="mode"/> Найти и заменить везде</label>
        <label><input type="radio" value="assign" v-model="mode"/> Назначить выбранным ({{ selectedIds.length }})</label>
      </div>

      <div v-if="mode === 'replace'">
        <label>Текущий адрес</label>
        <select v-model="from" class="form-select">
          <option v-for="u in usedUrls" :key="u.url" :value="u.url">
            {{ u.url }} — {{ u.count }} зап.
          </option>
        </select>
        <label>Новый адрес</label>
        <input v-model="to" list="massTrackerList" type="text" class="form-control" placeholder="Выберите токен или вставьте URL"/>
        <button class="btn btn-primary" :disabled="!from || !to || busy" @click="doReplace">Заменить</button>
      </div>

      <div v-if="mode === 'assign'">
        <div v-if="selectedIds.length === 0" class="text-muted">Отметьте записи галочками в списке слева.</div>
        <label>Новый urlA (пусто — не менять)</label>
        <input v-model="urlA" list="massTrackerList" type="text" class="form-control"/>
        <label>Новый urlB (пусто — не менять)</label>
        <input v-model="urlB" list="massTrackerList" type="text" class="form-control"/>
        <button class="btn btn-primary" :disabled="selectedIds.length === 0 || (!urlA && !urlB) || busy" @click="doAssign">Назначить</button>
      </div>

      <datalist id="massTrackerList">
        <option v-for="opt in trackerOptions" :key="opt.url" :value="opt.url">{{ opt.label }}</option>
      </datalist>

      <div v-if="result" class="mass-result text-success">{{ result }}</div>
      <div class="mass-actions">
        <button class="btn btn-outline-secondary" @click="$emit('close')">Закрыть</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    records: { type: Array, default: () => [] },
    selectedIds: { type: Array, default: () => [] },
    trackerOptions: { type: Array, default: () => [] },
  },
  emits: ['close', 'done'],
  data() {
    return {
      mode: 'replace',
      from: '', to: '', urlA: '', urlB: '',
      busy: false,
      result: '',
      hostApi: process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'http://localhost:5001',
    };
  },
  computed: {
    usedUrls() {
      const map = {};
      for (const r of this.records) {
        for (const u of new Set([r.urlA, r.urlB])) {
          if (!u) continue;
          if (!map[u]) map[u] = 0;
          map[u]++;
        }
      }
      return Object.keys(map).sort().map(url => ({ url: url, count: map[url] }));
    },
  },
  methods: {
    doReplace() {
      if (!window.confirm('Заменить\n' + this.from + '\nна\n' + this.to + '\nво всех записях?')) return;
      let vm = this;
      vm.busy = true;
      axios.post(vm.hostApi + '/api/v1/balansir/massReplaceUrl', { from: vm.from, to: vm.to })
        .then(function (response) {
          const d = response.data.data;
          vm.result = 'Заменено: ' + d.nodes + ' нод в ' + d.groups + ' записях';
          vm.$emit('done');
        })
        .catch(function (error) { console.log(error); alert('Ошибка замены: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)); })
        .finally(function () { vm.busy = false; });
    },
    doAssign() {
      if (!window.confirm('Назначить адреса ' + this.selectedIds.length + ' выбранным записям?')) return;
      let vm = this;
      vm.busy = true;
      axios.post(vm.hostApi + '/api/v1/balansir/massSetUrl', {
        groupIds: vm.selectedIds,
        urlA: vm.urlA || null,
        urlB: vm.urlB || null,
      })
        .then(function (response) {
          vm.result = 'Обновлено записей: ' + response.data.data.groups;
          vm.$emit('done');
        })
        .catch(function (error) { console.log(error); alert('Ошибка назначения: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)); })
        .finally(function () { vm.busy = false; });
    },
  },
};
</script>

<style scoped>
.mass-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.4); display: flex; align-items: center; justify-content: center; z-index: 1050; }
.mass-modal { background: var(--surface-1); color: var(--text-primary); border-radius: 6px; padding: 1.5em; width: 640px; max-width: 95vw; text-align: left; }
.mass-modal label { margin-top: 0.7em; font-weight: bold; display: block; }
.mode-switch { display: flex; gap: 1.5em; margin: 0.5em 0; }
.mass-modal .btn-primary { margin-top: 1em; }
.mass-result { margin-top: 1em; }
.mass-actions { margin-top: 1em; text-align: right; }
</style>
